import { WalletAdapterNetwork } from '@solana/wallet-adapter-base'

export const WALLET_ADAPTER_NETWORK = WalletAdapterNetwork.Devnet
